import React, { useState } from 'react';
import { Button, Card, Form } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';
import { Error, Success } from '../Alert/index';
import api from '../../services/api';

export function UsersCreate () {
  const history = useHistory();
  const [validated, setValidated] = useState(false);
  const [error, setError] = useState(false);
  const [success, setSuccess] = useState(false);

  const [values, setValues] = useState({});
  function handleChangeValues (event) {
    setValues({ ...values, [event.target.name]: event.target.value });
  }
  const handleSubmit = (event) => {
    const form = event.currentTarget;
    event.preventDefault();

    if (form.checkValidity() === false) {
      event.stopPropagation();
      setValidated(true);
    } else {
      api.post('/radius', {
        username: values.username,
        password: values.password,
      })
        .then(() => {
          setSuccess(true);
          setValues({
            username: '',
            password: '',
          });
          const element = document.getElementById('msgSuccess');
          element.innerHTML = 'Usuário cadastrado com sucesso';
          setTimeout(() => setSuccess(false), 3000);
        })
        .catch((err) => {
          if (err.response.status === 401) {
            setError(true);
            const element = document.getElementById('msgError');
            element.innerHTML = 'Sua sessão expirou. Realize o login novamente para continuar';
            setTimeout(() => {
              localStorage.removeItem('logged');
              localStorage.removeItem('realm');
              history.go('/login');
            }, 2000);
          } else {
            setError(true);
            const element = document.getElementById('msgError');
            element.innerHTML = err.response.data.error;
            setTimeout(() => setError(false), 3000);
          }
        });
    }
  };
  return (
    <div className="content-register">
      {error ? <Error><p id="msgError" /></Error> : null}
      {success ? <Success><p id="msgSuccess" /></Success> : null}
      <Card style={{ width: '23rem' }}>
        <Card.Header>
          <h5>Cadastro de usuário</h5>
        </Card.Header>
        <Card.Body>
          <Form noValidate validated={validated} onSubmit={handleSubmit}>
            <Form.Group controlId="formUsername">
              <Form.Label>Username (RA)</Form.Label>
              <Form.Control
                onChange={handleChangeValues}
                value={values.username}
                name="username"
                required
                type="text"
                placeholder="Entre com username"
              />
              <Form.Control.Feedback type="invalid">
                Por favor entre com username
              </Form.Control.Feedback>
            </Form.Group>
            <Form.Group controlId="formPassword">
              <Form.Label>Senha</Form.Label>
              <Form.Control
                onChange={handleChangeValues}
                value={values.password}
                name="password"
                required
                type="password"
                placeholder="Entre com a senha"
              />
              <Form.Control.Feedback type="invalid">
                Por favor entre com a senha
              </Form.Control.Feedback>
            </Form.Group>

            <Button block type="submit" variant="success">Cadastrar</Button>
          </Form>
        </Card.Body>
      </Card>
    </div>
  );
}
